import React from 'react';
import MarketWidget from './MarketWidget';
import PartnerShowcase from './PartnerShowcase';
import { useLocation } from 'react-router-dom';

/**
 * MainLayout - 3 Sütunlu Responsive Layout (Flex Tabanlı)
 * 
 * Yapı:
 * - Sol Sütun (w-72 = 288px): MarketWidget (Piyasa Özeti)
 * - Orta Sütun (flex-1): Ana içerik
 * - Sağ Sütun (w-80 = 320px): PartnerShowcase
 * 
 * Responsive:
 * - Desktop (xl+): 3 sütun
 * - Tablet (lg): 2 sütun (sağ gizli)
 * - Mobile: Tek sütun (tüm sidebar'lar alta)
 */
const MainLayout = ({ children, hideSidebars = false }) => {
    const location = useLocation();
    const isHome = location.pathname === '/';
    // Bazı sayfalarda (login, register vb.) sidebar gösterme
    if (hideSidebars) {
        return (
            <main className="flex-grow">
                {children}
            </main>
        );
    }

    return (
        <div className="w-full max-w-[1800px] mx-auto px-3 sm:px-4 lg:px-6 py-4 sm:py-6 overflow-x-clip transition-colors duration-300 ease-in-out">
            <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 min-w-0">
                {/* Sol Sütun - Desktop'ta görünür (lg+) */}
                <aside className="hidden lg:block w-72 flex-shrink-0">
                    <div className="sticky top-24 space-y-6">
                        <MarketWidget />
                    </div>
                </aside>

                {/* Orta Sütun - Ana İçerik (Flex-1 ile kalan alanı doldurur) */}
                <main className="w-full flex-1 min-w-0">
                    <div className="bg-white dark:bg-slate-800 shadow-lg rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 transition-colors duration-300 ease-in-out">
                        {children}
                    </div>
                </main>

                {/* Sağ Sütun - Geniş Desktop'ta görünür (xl+) */}
                <aside className="hidden xl:block w-80 flex-shrink-0">
                    <div className="sticky top-24 space-y-6">
                        <PartnerShowcase />
                    </div>
                </aside>
            </div>

            {/* Mobil için Sidebar'lar alta */}
            {!isHome && (
                <div className="lg:hidden mt-6 space-y-6 max-w-md mx-auto">
                    <MarketWidget />
                    <PartnerShowcase compact />
                </div>
            )}
            <div className="xl:hidden lg:block hidden mt-8">
                <div className="max-w-sm mx-auto"><PartnerShowcase /></div>
            </div>
        </div>
    );
};

export default MainLayout;
